// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppRouteImport } from './routes/app'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AppIndexRouteImport } from './routes/app.index'
import { Route as AppChaosMapRouteImport } from './routes/app.chaos-map'
import { Route as AppNotificationsRouteImport } from './routes/app.notifications'
import { Route as AppQueueRouteImport } from './routes/app.queue'
import { Route as AppSearchRouteImport } from './routes/app.search'
import { Route as AppSettingsRouteImport } from './routes/app.settings'
import { Route as ShareTokenRouteImport } from './routes/share.$token'
import { Route as AppChatConversationIdRouteImport } from './routes/app.chat.$conversationId'
import { Route as AppLoopsLoopIdRouteImport } from './routes/app.loops.$loopId'
import { Route as OauthGmailReturnRouteImport } from './routes/oauth.gmail.return'
import { Route as OauthGoogleCalendarReturnRouteImport } from './routes/oauth.google-calendar.return'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AppRoute = AppRouteImport.update({
            id: '/app',path: '/app',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const AppIndexRoute = AppIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppRoute
          })
const AppChaosMapRoute = AppChaosMapRouteImport.update({
            id: '/chaos-map',path: '/chaos-map',getParentRoute: () => AppRoute
          })
const AppNotificationsRoute = AppNotificationsRouteImport.update({
            id: '/notifications',path: '/notifications',getParentRoute: () => AppRoute
          })
const AppQueueRoute = AppQueueRouteImport.update({
            id: '/queue',path: '/queue',getParentRoute: () => AppRoute
          })
const AppSearchRoute = AppSearchRouteImport.update({
            id: '/search',path: '/search',getParentRoute: () => AppRoute
          })
const AppSettingsRoute = AppSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AppRoute
          })
const ShareTokenRoute = ShareTokenRouteImport.update({
            id: '/share/$token',path: '/share/$token',getParentRoute: () => rootRouteImport
          })
const AppChatConversationIdRoute = AppChatConversationIdRouteImport.update({
            id: '/chat/$conversationId',path: '/chat/$conversationId',getParentRoute: () => AppRoute
          })
const AppLoopsLoopIdRoute = AppLoopsLoopIdRouteImport.update({
            id: '/loops/$loopId',path: '/loops/$loopId',getParentRoute: () => AppRoute
          })
const OauthGmailReturnRoute = OauthGmailReturnRouteImport.update({
            id: '/oauth/gmail/return',path: '/oauth/gmail/return',getParentRoute: () => rootRouteImport
          })
const OauthGoogleCalendarReturnRoute = OauthGoogleCalendarReturnRouteImport.update({
            id: '/oauth/google-calendar/return',path: '/oauth/google-calendar/return',getParentRoute: () => rootRouteImport
          })





const AppRouteChildren = {
  AppChaosMapRoute: AppChaosMapRoute,AppNotificationsRoute: AppNotificationsRoute,AppQueueRoute: AppQueueRoute,AppSearchRoute: AppSearchRoute,AppSettingsRoute: AppSettingsRoute,AppIndexRoute: AppIndexRoute,AppChatConversationIdRoute: AppChatConversationIdRoute,AppLoopsLoopIdRoute: AppLoopsLoopIdRoute
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AppRoute: AppRouteWithChildren,AuthRoute: AuthRoute,ShareTokenRoute: ShareTokenRoute,OauthGmailReturnRoute: OauthGmailReturnRoute,OauthGoogleCalendarReturnRoute: OauthGoogleCalendarReturnRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)